import React from 'react';

import { VirtualTourComposerProps } from 'Common/util/cmsComposer/VirtualTour';

import Grid, { Col } from 'Components/Grid';
import ImageAnimated from 'Components/Card/ImageAnimated';
import Listing, { ListingCardProps } from 'Components/Card/Listing';

import { Wrapper, ListingCardWrapper } from './VirtualTour.styled';

const VirtualTourBlockRenderer = (
    content: VirtualTourComposerProps[],
    promoCard?: ListingCardProps
): React.ReactNode => {
    return content.map((item, index) => (
        <React.Fragment key={index}>
            {item.virtualToursCards && item.virtualToursCards.tourCards.length === 1 && (
                <Wrapper>
                    <Grid>
                        <Col>
                            <ImageAnimated {...item.virtualToursCards.tourCards[0]} />
                        </Col>
                    </Grid>
                </Wrapper>
            )}
            {item.virtualToursCards && item.virtualToursCards.tourCards.length === 2 && (
                <Wrapper>
                    <Grid rowGap={'1.5rem'}>
                        {item.virtualToursCards.tourCards.map((card, index) => (
                            <Col m={6} key={index}>
                                <ImageAnimated {...card} key={index} />
                            </Col>
                        ))}
                    </Grid>
                </Wrapper>
            )}
            {item.virtualToursCards &&
                item.virtualToursCards.tourCards.length === 3 &&
                !item.virtualToursCards.addPromo && (
                    <Wrapper>
                        <Grid rowGap={'1.5rem'}>
                            {item.virtualToursCards.tourCards.slice(0, 2).map((card, index) => (
                                <Col m={6} l={4} key={index}>
                                    <ImageAnimated {...card} key={index} />
                                </Col>
                            ))}
                            {item.virtualToursCards.tourCards.slice(2, 3).map((card, index) => (
                                <Col l={4} key={index}>
                                    <ImageAnimated {...card} key={index} />
                                </Col>
                            ))}
                        </Grid>
                    </Wrapper>
                )}
            {promoCard &&
                item.virtualToursCards &&
                item.virtualToursCards.tourCards.length === 3 &&
                item.virtualToursCards.addPromo && (
                    <Wrapper>
                        <Grid rowGap={'1.5rem'}>
                            <Col m={6} l={3}>
                                <ImageAnimated {...item.virtualToursCards.tourCards[0]} />
                            </Col>
                            <Col m={6} l={3}>
                                <ImageAnimated {...item.virtualToursCards.tourCards[1]} />
                            </Col>
                            <Col m={[3, 11]} l={3}>
                                <ListingCardWrapper>
                                    <Listing {...promoCard} />
                                </ListingCardWrapper>
                            </Col>
                            <Col l={3} key={2}>
                                <ImageAnimated {...item.virtualToursCards.tourCards[2]} />
                            </Col>
                        </Grid>
                    </Wrapper>
                )}
        </React.Fragment>
    ));
};

export default VirtualTourBlockRenderer;
